import React from "react";
import UserMenuInputComponent from "../../shared/user-menu/UserMenuInputComponent";
import UserMenuButtonComponent from "../../shared/user-menu/UserMenuButtonComponent";
import { useAppSelector } from "@hypexone/uicore";

interface ChangePasswordProps {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
  updateNewPassword: Function;
  setOldPassword: Function;
  setNewPassword: Function;
  setConfirmPassword: Function;
  resetPassword?: Function;
  disable?: boolean;
}
const ChangePasswordTab: React.FC<ChangePasswordProps> = ({
  oldPassword,
  newPassword,
  confirmPassword,
  updateNewPassword,
  setOldPassword,
  setNewPassword,
  setConfirmPassword,
  resetPassword,
}) => {
  const { langData } = useAppSelector((state) => state.cms);
  const fieldKeys = [
    {
      label: "Old Password",
      langKey: "old_password",
      value: oldPassword,
    },
    {
      label: "New Password",
      langKey: "new_password",
      value: newPassword,
    },
    {
      label: "Confirm Password",
      langKey: "confirm_password",
      value: confirmPassword,
    },
  ];

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    detail: { label: any; value: string }
  ) => {
    detail.label === "Old Password"
      ? setOldPassword(e.target.value)
      : detail.label === "New Password"
      ? setNewPassword(e.target.value)
      : setConfirmPassword(e.target.value);
  };

  return (
    <div className="flex flex-col p-3 gap-2 h-full w-full">
      <div>
        {fieldKeys.map((fieldKey, index) => (
          <div className="flex flex-col max-w-[400px]" key={index}>
            <div className="text-[#6c757d] text-[14px]">
              {langData?.[fieldKey.langKey] ?? fieldKey.label}
            </div>
            <UserMenuInputComponent
              type="password"
              placeholder={
                langData?.[`enter_${fieldKey.langKey}`] ||
                `Enter ${langData?.[fieldKey.langKey] ?? fieldKey.label}`
              }
              value={fieldKey.value || ""}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange(e, fieldKey)
              }
            />
          </div>
        ))}
      </div>
      <UserMenuButtonComponent
        buttonText={langData?.["update_password"] ?? "Update Password"}
        onClick={(e) => {
          e.preventDefault();
          updateNewPassword();
        }}
      />
    </div>
  );
};

export default ChangePasswordTab;
